import React from "react";
import CheckboxAction from "./main.content.checkbox.action";
import BtnView from "./main.content.btn.view";
import { useAlluser } from "context/AlluserContext";

export default function TrContent({ data, setData }) {
  const { filterData } = useAlluser();
  const userFields = filterData?.userFields ?? [];
  const colspan = userFields.length + 3;
  const userSess = data.userData.user_sess;
  const allUserData = data.allUserData;
  let list = [];
  for (const i in allUserData) {
    list.push(
      <tr key={"row-" + i}>
        <Feature.TdContent
          data={allUserData[i]}
          index={i}
          actionData={data.actionData}
          userSess={userSess}
          setActionData={setData.setActionData}
          userFields={userFields}
        />
      </tr>
    );
  }
  if (allUserData.length === 0) {
    list.push(
      <tr key="row-1">
        <td colSpan={colspan}>No Data</td>
      </tr>
    );
  }
  return list;
}

const Feature = {};
Feature.TdContent = ({
  data,
  index,
  actionData,
  userSess,
  setActionData,
  userFields,
}) => {
  const profileTab =
    (userSess?.isITManager || userSess?.isInfoSysManager) &&
    !userSess?.userCanAccessHrAssign &&
    !userSess?.isAdmin
      ? "notification"
      : "employeeinfo";
  let td = [];
  let userPhoto = "";
  if (data.photo !== "") {
    userPhoto = (
      <div
        className="image-circle"
        style={{
          background: "url('" + data.photo + "') no-repeat center",
          backgroundSize: "cover",
          width: "56px",
          height: "56px",
        }}
      />
    );
  } else {
    userPhoto = (
      <div className="image-circle" style={{ width: "56px", height: "56px" }}>
        <i className="material-icons" style={{ marginLeft: "0px" }}>
          person
        </i>
      </div>
    );
  }
  td.push(
    <td key={"row-" + index + "-col-photo"} className="td-photo">
      {userPhoto}
    </td>
  );
  for (const i in userFields) {
    const field = userFields[i];
    if (field === "active") continue;
    if (field === "name") {
      td.push(
        <td key={"row-" + index + "-col-" + field} className="text-left">
          <a
            href={"/employees/profile/?tab=" + profileTab + "&id=" + data.idu}
            target="_self"
            rel="noreferrer"
          >
            <span className="text">{data.name}</span>
          </a>
        </td>
      );
    } else if (field === "idu") {
      td.push(
        <td key={"row-" + index + "-col-" + field} className="text-center">
          <a
            href={"/employees/profile/?tab=" + profileTab + "&id=" + data.idu}
            target="_blank"
            rel="noreferrer"
          >
            <span className="text">{data.idu}</span>
          </a>
        </td>
      );
    } else {
      td.push(
        <td key={"row-" + index + "-col-" + field} className="text-center">
          <span className="text">{data?.[field] ?? "N/A"}</span>
        </td>
      );
    }
  }
  if (userFields.indexOf("active") >= 0) {
    td.push(
      <td key={"row-" + index + "-col-active"}>
        <div className={"active-text " + data.active}>
          {data.active === "Y" ? "Yes" : "No"}
        </div>
      </td>
    );
  }
  td.push(
    <td key={"row-" + index + "-col-view"}>
      <BtnView id={data.idu} />
    </td>
  );
  if (userSess?.userCanAccessHrAssign && userSess?.isAdmin) {
    td.push(
      <td key={"row-" + index + "-col-action"} className="text-center">
        <CheckboxAction
          data={data}
          index={index}
          actionData={actionData}
          setActionData={setActionData}
        />
      </td>
    );
  }
  return td;
};
